module.exports = __webpack_public_path__ + "img/Menu-04.c62f39e1.png";